<script setup lang="ts"></script>

<template>
  <UIFormInput variant="outlined" />
</template>
